/**
 * Links the public website (asport.lv home, footer) points to, defined once.
 */
import { SUPPORT_EMAIL } from '@/js/constants/contactDetails'

/**
 * "Parunāsim — 15 min" for studios: an e-mail to ASport for now (Ansis 2026-10-25: e-mail, no phone
 * on the site yet). A contact form is out of scope — it would store personal data.
 * @param {string} subject localized subject line
 */
export function studioContactHref (subject) {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`
}

/**
 * The studio page shown as a live example ("Apskati reālu lapu"). A real customer page, chosen by
 * Ansis 2026-10-25; replace with the ASport demo studio (`demo-studija`) when it exists
 * (myAI/projects/asport/plans/demo-studio.md).
 */
export const EXAMPLE_STUDIO_IDENTIFIER = 'vingro-ar-signi'

/**
 * For a link to the page the visitor is already on (the logo on the home page): the router does not
 * navigate to the same route, so nothing would happen — scroll back to the top instead.
 * @param {Object} route the current `$route`
 * @param {string} targetPath the link's localized path
 */
export function scrollToTopIfAlreadyOn (route, targetPath) {
  if (route.path === targetPath) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

/** Days a trainer uses ASport free before the first invoice (trainer path only, not larger studios). */
export const FREE_TRIAL_DAYS = 30
